import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";

export default function AdvanceMembers() {
  const [advanceMembers, setAdvanceMembers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const loadAdvanceMembers = async () => {

      /* ================= MEMBERS ================= */
      const membersSnap = await getDocs(collection(db, "members"));
      const members = {};

      membersSnap.forEach(doc => {
        const m = doc.data();
        if (!m.memberId) return;

        members[m.memberId] = {
          name: m.name || "",
          mobile: m.mobile || "",
        };
      });

      /* ================= LEDGER ================= */
      const ledgerSnap = await getDocs(collection(db, "savingLedger"));

      const calc = {};

      ledgerSnap.forEach(doc => {
        const l = doc.data();
        if (!l.memberId) return;

        if (!calc[l.memberId]) {
          calc[l.memberId] = { credit: 0, debit: 0 };
        }

        // 🔥 SUPPORT BOTH FORMATS
        if (l.type === "CREDIT") calc[l.memberId].credit += Number(l.amount || 0);
        if (l.type === "DEBIT") calc[l.memberId].debit += Number(l.amount || 0);

        if (l.deposit) calc[l.memberId].credit += Number(l.deposit || 0);
        if (l.withdrawal) calc[l.memberId].debit += Number(l.withdrawal || 0);
      });

      /* ================= ADVANCE ================= */
      const list = Object.keys(calc)
        .map(memberId => {
          const balance = calc[memberId].credit - calc[memberId].debit;

          return {
            memberId,
            memberName: members[memberId]?.name || "",
            mobile: members[memberId]?.mobile || "",
            advanceAmount: balance,
          };
        })
        .filter(m => m.advanceAmount > 0);

      console.log("✅ ADVANCE MEMBERS FINAL", list);
      setAdvanceMembers(list);
    };

    loadAdvanceMembers();
  }, []);

  /* ================= UI ================= */
  const sendWhatsApp = (m) => {
    if (!m.mobile) return alert("Mobile not found");

    const msg = `Dear ${m.memberName},
Your saving account has advance balance ₹${m.advanceAmount}.`;

    window.open(
      `https://wa.me/91${m.mobile}?text=${encodeURIComponent(msg)}`,
      "_blank"
    );
  };

  const viewLedger = (memberId) => {
    navigate(`/saving-ledger?memberId=${memberId}`);
  };

  return (
    <div className="container-fluid">
      <h4 className="mb-3">Advance Members</h4>

      <table className="table table-bordered table-sm text-center">
        <thead className="table-dark">
          <tr>
            <th>Sr</th>
            <th>Name</th>
            <th>Member ID</th>
            <th>Mobile</th>
            <th>Advance Amount</th>
            <th>WhatsApp</th>
            <th>Ledger</th>
          </tr>
        </thead>

        <tbody>
          {advanceMembers.length === 0 && (
            <tr>
              <td colSpan="7" className="text-danger">
                ❌ No Advance Members
              </td>
            </tr>
          )}

          {advanceMembers.map((m, i) => (
            <tr key={m.memberId}>
              <td>{i + 1}</td>
              <td>{m.memberName}</td>
              <td>{m.memberId}</td>
              <td>{m.mobile}</td>
              <td className="fw-bold text-success">₹ {m.advanceAmount}</td>
              <td>
                <button className="btn btn-success btn-sm" onClick={() => sendWhatsApp(m)}>
                  WhatsApp
                </button>
              </td>
              <td>
                <button className="btn btn-primary btn-sm" onClick={() => viewLedger(m.memberId)}>
                  View Ledger
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}